import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import AdminLogin from "./components/AdminLogin";
import Navbar from "./components/Navbar";
import UploadImage from "./components/UploadImage";
import Footer from "./components/Footer"; // ✅ ADD THIS
import BhanwarkuaHostel from "./pages/BhanwarkuaHostel";


import { auth } from "./firebase";

import About from "./pages/About";
import Amenities from "./pages/Amenities";
import Booking from "./pages/Booking";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import RoomSeaterPage from "./pages/RoomSeaterPage";

function App() {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAdmin(user);
    });
    return () => unsubscribe();
  }, []);

  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/about" element={<About />} />
        <Route path="/rooms" element={<Rooms isAdmin={!!admin} />} />
        <Route path="/rooms/:seater" element={<RoomSeaterPage />} />
        <Route path="/amenities" element={<Amenities />} />
        <Route path="/gallery" element={<Gallery isAdmin={admin} />} />
        <Route path="/admin/upload" element={<UploadImage />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/girls-hostel-bhanwarkua-indore" element={<BhanwarkuaHostel />} />
      </Routes>

      {/* ✅ ADD THIS */}
      <Footer />

      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        pauseOnFocusLoss
      />
    </Router>
  );
}

export default App;
